import { Host, h } from '@stencil/core';
// import { data } from './_mock/ageMock.json';
export class AibaAgeCompare {
  constructor() {
    this.data = undefined;
    this.handlers = undefined;
  }
  render() {
    return (h(Host, null, h("div", { class: "aiba-age-compare-wrapper" }, this.data &&
      this.data.elements.map((element) => {
        if (element.name === 'aiba-label')
          return h("aiba-label", Object.assign({}, element['data']));
        if (element.name === 'aiba-option-selection')
          return h("aiba-option-selection", Object.assign({}, element['data'], { handlers: this.handlers }));
      }))));
  }
  static get is() { return "aiba-age-compare"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-age-compare.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-age-compare.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-age-compare.js.map
